import { useContext, useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { UserContext } from "../Context/UserContext";
import axios from "axios";
import { Form, Button, InputNumber, Descriptions } from 'antd'
import { ArrowLeftOutlined } from "@ant-design/icons"

function FormOrder(){
    let {id} = useParams()
    const history = useHistory();
    const [user,,,setDashboard] = useContext(UserContext);
    const [ product, setProduct ] = useState({})
    const [form] = Form.useForm();

    setDashboard(false)

    const HandleBack = () => {
        history.goBack()
    }

    useEffect(()=>{
        const fetchData = async()=>{
            let result = await axios.get(`https://backend-sportyan.vercel.app/api/products/${id}`)
            let dataProduct = result.data
            setProduct(dataProduct) 
        }
        fetchData()
        form.setFieldsValue({
            productId: product.id
        })
    }, [id, form, product.id])

    const onFinish = (values) => {
        axios.post("https://backend-sportyan.vercel.app/api/order", {...values}, {headers: {"Authorization" : "Bearer "+ user.token}})
            .then(()=>{
                history.push("/cart")
                window.location.reload()
            })
    };

    const onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };


    return (
        <>
        <Button type="danger" icon={<ArrowLeftOutlined />} size="large" style={{marginBottom: "40px"}} onClick={HandleBack}>
            Kembali
        </Button>
        <Descriptions title="Ringkasan Pemesanan Produk" bordered >    
            <Descriptions.Item label="Nama Produk" span={3}>{product.name}</Descriptions.Item> 
            <Descriptions.Item label="Harga"span={3}>{product.price}</Descriptions.Item>
        </Descriptions>
        <br></br>
        <Form
            name="basic"
            form={form}
            labelCol={{
                span: 4,
            }}
            wrapperCol={{
                span: 16,
            }}
            initialValues={{
                quantity: 1
            }}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete="off"
        >
            <Form.Item
                label="Jumlah"
                name="quantity"
                >
                <InputNumber max={product.stock} min={1} />
            </Form.Item>

            <Form.Item
                style={{display: 'none'}}
                label="Id Produk"
                name="productId"
                >
                <InputNumber />
            </Form.Item>

            <Form.Item
                wrapperCol={{
                    offset: 4,
                    span: 16,
                }}
                >
                <Button type="primary" htmlType="submit">
                Tambah ke Shop Cart
                </Button>
            </Form.Item>
        </Form>

        </>
    )
}

export default FormOrder;